module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-scenes"
  }, [(!_vm.hasRelays) ? _c('el-alert', {
    staticStyle: {
      "margin-top": "10px",
      "font-weight": "bold",
      "color": "black"
    },
    attrs: {
      "title": "WARNING: Field has no relays",
      "type": "warning",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panelheader border-4"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/admin/clients'
      }
    }
  }, [_vm._v("Clients Admin")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/admin/clients/' + _vm.clientId
      }
    }
  }, [_vm._v("Sites Admin")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: ("/admin/clients/" + _vm.clientId + "/site/" + _vm.siteId)
      }
    }
  }, [_vm._v("Fields Admin")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.pageName))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "add"
    },
    on: {
      "click": _vm.onNewScene
    }
  }, [_vm._v("New Scene")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "scenes"
  }, [_c('h2', [_vm._v(" " + _vm._s(_vm.fieldName) + " ")]), _vm._v(" "), (_vm.newScene) ? _c('div', [_c('newscene', {
    attrs: {
      "fieldId": _vm.id
    },
    on: {
      "close": _vm.onClose
    }
  })], 1) : (_vm.editScene) ? _c('div', [_c('editscene', {
    attrs: {
      "fieldId": _vm.id,
      "sceneData": _vm.sceneData
    },
    on: {
      "close": _vm.onClose
    }
  })], 1) : _c('div', [(!_vm.reloading) ? _c('scenetable', {
    attrs: {
      "id": _vm.id
    },
    on: {
      "editScene": _vm.onEditScene,
      "deleteScene": _vm.onDeleteScene
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4906d046","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Scenes/Scenes.vue
// module id = 1042
// module chunks = 5